import React from 'react';
import { AlkmaarSkyline } from './AlkmaarSkyline';
import { ArrowRightIcon } from 'lucide-react';
export function LocalAuthoritySection() {
  const scrollToContact = (e: React.MouseEvent) => {
    e.preventDefault();
    document.getElementById('contact')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section id="regio" className="relative py-24 lg:py-28 bg-white overflow-hidden" data-id="element-701">
      {/* Skyline background */}
      <div className="absolute bottom-0 left-0 right-0 opacity-30 pointer-events-none" data-id="element-702">
        <AlkmaarSkyline className="w-full h-auto" color="#9FB3C8" data-id="element-703" />
      </div>

      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-704">
        <h2 className="text-3xl lg:text-4xl font-bold text-navy-900 text-center mb-8" data-id="element-705">
          Webdesign bureau in Alkmaar en omgeving
        </h2>

        <div className="max-w-3xl mx-auto" data-id="element-706">
          <p className="text-lg text-navy-700 leading-relaxed text-center mb-6" data-id="element-707">
            Als specialist in <strong data-id="element-708">webdesign in Alkmaar</strong> helpen wij
            lokale ondernemers met professionele websites die écht werken. Of je
            nu een <strong data-id="element-709">website wilt laten maken in Alkmaar</strong>, op zoek
            bent naar een <strong data-id="element-710">WordPress specialist in Alkmaar</strong>, of
            je <strong data-id="element-711">online zichtbaarheid in Alkmaar</strong> wilt verbeteren
            — wij staan voor je klaar.
          </p>
          <p className="text-base text-navy-600 leading-relaxed text-center mb-10" data-id="element-712">
            Wij werken voor ondernemers in <strong data-id="element-713">Alkmaar</strong>,{' '}
            <strong data-id="element-714">Bergen</strong>, <strong data-id="element-715">Heiloo</strong>,{' '}
            <strong data-id="element-716">Heerhugowaard</strong>, <strong data-id="element-717">Castricum</strong>,{' '}
            <strong data-id="element-718">Langedijk</strong> en de rest van de regio Noord-Holland
            Noord. Met onze kennis van de lokale markt zorgen wij ervoor dat
            jouw bedrijf online opvalt bij klanten in de buurt.
          </p>

          <p className="text-lg text-slate-600 mb-8 leading-relaxed" data-id="element-719">
            Of je nu een nieuwe website wilt laten maken, beter gevonden wilt
            worden in Google, of je huidige website wilt vernieuwen en
            verbeteren. Wij staan voor je klaar.
          </p>

          {/* Internal links - SEO Silo */}
          <div className="flex flex-wrap items-center justify-center gap-3 mb-10" data-id="element-720">
            <a href="#/webdesign-alkmaar" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-721">
              Webdesign Alkmaar
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-722" />
            </a>
            <a href="#/webdesign-heerhugowaard" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-723">
              Webdesign Heerhugowaard
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-724" />
            </a>
            <a href="#/webdesign-hoorn" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-725">
              Webdesign Hoorn
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-726" />
            </a>
            <a href="#/webdesign-schagen" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-727">
              Webdesign Schagen
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-728" />
            </a>
            <a href="#/webdesign-den-helder" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-729">
              Webdesign Den Helder
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-730" />
            </a>
            <a href="#/website-laten-maken-alkmaar" className="inline-flex items-center gap-1.5 bg-accent-light text-accent font-medium text-sm px-4 py-2 rounded-full hover:bg-accent hover:text-white transition-all duration-200" data-id="element-731">
              Website laten maken Alkmaar
              <ArrowRightIcon className="w-3.5 h-3.5" data-id="element-732" />
            </a>
          </div>

          <div className="text-center" data-id="element-733">
            <a href="#contact" onClick={scrollToContact} className="inline-flex items-center gap-2 bg-accent hover:bg-accent-hover text-white font-semibold px-8 py-4 rounded-button shadow-medium hover:shadow-card transition-all duration-200 text-base group" data-id="element-734">
              Neem contact op
              <ArrowRightIcon className="w-5 h-5 group-hover:translate-x-1 transition-transform duration-200" data-id="element-735" />
            </a>
          </div>
        </div>
      </div>
    </section>;
}